import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { api } from '../api.js'

// Org info (name, contact, currency label) fetched once on app mount, shared
// via context, refreshed after the admin saves the organization form. The
// currency label is VISUAL ONLY and always rendered AFTER the value:
// `120 LEI` — use fmtPrice() everywhere a price is shown.

const FALLBACK = {
  name: 'Centrul de Excelență BBSO',
  email: null,
  phone: null,
  currency_label: 'LEI',
}

const OrgContext = createContext({
  org: FALLBACK,
  loading: true,
  refresh: () => {},
})

export function OrgProvider({ children }) {
  const [org, setOrg]         = useState(FALLBACK)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(() => {
    setLoading(true)
    return api.org()
      .then((d) => { if (d?.organization) setOrg({ ...FALLBACK, ...d.organization }) })
      .catch(() => { /* keep current value on failure */ })
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => { refresh() }, [refresh])

  return (
    <OrgContext.Provider value={{ org, loading, refresh }}>
      {children}
    </OrgContext.Provider>
  )
}

export function useOrg() {
  return useContext(OrgContext)
}

/** "120 LEI" — currency label after the value, per project convention. */
export function useFmtPrice() {
  const { org } = useOrg()
  return (value) => `${value} ${org.currency_label || 'LEI'}`
}
